(function initVatCodeCatalog(global) {
  // Hvilke MVA-koder som i det hele tatt finnes eies av backend
  // (getManualVatOptions kjenner land og MVA-registrering). Denne katalogen
  // legger bare paa forklaringene menyen viser, og filtrerer bort koder som
  // hoerer til motsatt retning: en kostnadslinje skal ikke kunne velge en
  // salgskode, og en inntektslinje ikke en fradragskode.
  const MANUAL_GROUP_ORDER = [
    ['none', 'vatCode.group.none', 'Ingen MVA-kode'],
    ['input', 'vatCode.group.input', 'Kjøp · inngående MVA'],
    ['vatOnly', 'vatCode.group.vatOnly', 'Kun MVA'],
    ['importBasis', 'vatCode.group.importBasis', 'Kun grunnlag for MVA'],
    ['reverse', 'vatCode.group.reverse', 'Kjøp fra utlandet · snudd avregning'],
    ['output', 'vatCode.group.output', 'Salg · utgående MVA'],
    ['other', 'vatCode.group.other', 'Andre valg'],
  ];

  const PURCHASE_SCOPE = ['vatCode.scope.purchase', 'Kjøpsside'];
  const SALE_SCOPE = ['vatCode.scope.sale', 'Salgsside'];
  const NEUTRAL_SCOPE = ['vatCode.scope.manual', 'Manuell føring'];
  const ABROAD_SCOPE = ['vatCode.scope.abroad', 'Kjøp fra utlandet'];
  const INPUT_EFFECT = ['vatCode.manual.inputEffect', 'Plumme skiller MVA fra beløpet og fører den som fradragsberettiget inngående MVA i MVA-meldingen.'];
  const OUTPUT_EFFECT = ['vatCode.manual.outputEffect', 'Plumme skiller utgående MVA fra inntekten og tar den med i MVA-meldingen.'];

  // [gruppe, retning, omfang, kontekst, virkning]
  const MANUAL_CODES = {
    'none': ['none', '', NEUTRAL_SCOPE,
      ['vatCode.manual.noneContext', 'Linjen føres uten MVA-kode.'],
      ['vatCode.manual.noneEffect', 'Hele beløpet føres på kontoen, og linjen påvirker ikke MVA-meldingen.']],
    'input-25': ['input', 'purchase', PURCHASE_SCOPE,
      ['vatCode.manual.input25Context', 'Bilaget viser 25 % norsk MVA, og kjøpet gir fradragsrett.'], INPUT_EFFECT],
    'input-15': ['input', 'purchase', PURCHASE_SCOPE,
      ['vatCode.manual.input15Context', 'Bilaget viser 15 % norsk MVA, normalt ved kjøp av næringsmidler, og kjøpet gir fradragsrett.'], INPUT_EFFECT],
    'input-12': ['input', 'purchase', PURCHASE_SCOPE,
      ['vatCode.manual.input12Context', 'Bilaget viser 12 % norsk MVA, blant annet ved persontransport eller overnatting, og kjøpet gir fradragsrett.'], INPUT_EFFECT],
    'import-vat-only-25': ['vatOnly', 'purchase', PURCHASE_SCOPE,
      ['vatCode.manual.importVatOnlyContext', 'Brukes bare når 25 % innførsels-MVA er betalt til Tolletaten eller speditør og skal føres direkte til fradrag.'],
      ['vatCode.manual.importVatOnlyEffect', 'Hele beløpet føres direkte som inngående MVA på konto 2710, uten kostnadskonto.']],
    'import-basis-25': ['importBasis', 'purchase', ABROAD_SCOPE,
      ['vatCode.manual.importBasis21Context', 'Faktura fra utenlandsk selger for varer og relevante tilleggsutgifter som omfattes av 25 % innførsels-MVA.'],
      ['vatCode.manual.importBasis21Effect', 'Beløpet bokføres som kostnad uten MVA. Tolldeklarasjonen registreres senere separat med kode 81.']],
    'import-basis-zero': ['importBasis', 'purchase', ABROAD_SCOPE,
      ['vatCode.manual.importBasis23Context', 'Faktura fra utenlandsk selger for varer som ikke skal ha beregnet innførsels-MVA.'],
      ['vatCode.manual.importBasis23Effect', 'Beløpet bokføres som kostnad uten MVA og påvirker ikke MVA-meldingen. Tolldeklarasjonen registreres separat med kode 85.']],
    'reverse-services-25': ['reverse', 'purchase', ABROAD_SCOPE,
      ['vatCode.manual.reverseServicesContext', 'Fjernleverbare tjenester kjøpt fra en utenlandsk leverandør, der fakturaen ikke viser norsk MVA.'],
      ['vatCode.manual.reverseServicesEffect', 'Beløpet er avgiftsgrunnlaget. Plumme beregner utgående MVA og fører tilsvarende fradrag når kjøpet gir fradragsrett.']],
    'reverse-goods-25': ['reverse', 'purchase', ABROAD_SCOPE,
      ['vatCode.manual.reverseGoodsContext', 'Innførsel av varer der virksomheten selv beregner innførsels-MVA. Grunnlaget skal hentes fra tolldeklarasjonen, ikke nødvendigvis fra fakturabeløpet.'],
      ['vatCode.manual.reverseGoodsEffect', 'Beløpet er avgiftsgrunnlaget. Plumme beregner innførsels-MVA og fører tilsvarende fradrag når innførselen gir fradragsrett.']],
    'output-25': ['output', 'sale', SALE_SCOPE,
      ['vatCode.manual.output25Context', 'Salget er avgiftspliktig med alminnelig sats 25 %.'], OUTPUT_EFFECT],
    'output-15': ['output', 'sale', SALE_SCOPE,
      ['vatCode.manual.output15Context', 'Salget er avgiftspliktig med middels sats 15 %, normalt næringsmidler.'], OUTPUT_EFFECT],
    'output-12': ['output', 'sale', SALE_SCOPE,
      ['vatCode.manual.output12Context', 'Salget er avgiftspliktig med lav sats 12 %, blant annet persontransport, overnatting og adgang til kultur og idrett.'], OUTPUT_EFFECT],
  };

  const UNKNOWN_META = ['other', '', NEUTRAL_SCOPE,
    ['vatCode.manual.unknownContext', 'MVA-koden er ikke tilgjengelig for denne virksomheten.'],
    ['vatCode.manual.unknownEffect', 'Velg en annen kode, eller la linjen stå uten MVA-behandling.']];

  // Kontoen avgjoer retningen: salgsinntekt gir utgaaende MVA, varekjoep og
  // kostnad gir inngaaende. Andre kontoklasser faar ingen retning, og da vises
  // hele det tilgjengelige settet i stedet for aa gjette.
  const DIRECTION_BY_PREFIX = [[/^3/, 'sale'], [/^[467]/, 'purchase']];

  const directionForAccount = (account) => {
    const code = global.PlummeManualPostingRules?.accountCode?.(account) || '';
    return DIRECTION_BY_PREFIX.find(([pattern]) => pattern.test(code))?.[1] || '';
  };

  const manualOption = (option, meta) => {
    const [group, direction, scope, context, effect] = meta;
    return {
      value: option.value,
      label: option.label,
      group,
      direction,
      scopeKey: scope[0],
      scopeFallback: scope[1],
      contextKey: context[0],
      contextFallback: context[1],
      effectKey: effect[0],
      effectFallback: effect[1],
      selectable: option.disabled !== true,
    };
  };

  const manualGroups = ({ options = [], direction = '', value = '' } = {}) => {
    const available = Array.isArray(options) ? [...options] : [];
    // A removed choice may still exist on historical postings. Keep the
    // current known value readable without offering it on new lines.
    if (value && MANUAL_CODES[value] && !available.some((option) => option.value === value)) {
      available.push({ value, label: value === 'import-vat-only-25' ? '14 - Kun inngående MVA 25 %' : value });
    }
    const decorated = available
      .map((option) => manualOption(option, MANUAL_CODES[option.value] || UNKNOWN_META))
      // Retningsfilteret skal aldri skjule koden linjen alt har. Ellers ville en
      // aapnet postering miste sin egen MVA-kode fordi kontoen peker motsatt vei.
      .filter((option) => !direction || !option.direction || option.direction === direction || option.value === value);
    return MANUAL_GROUP_ORDER
      .map(([key, labelKey, fallback]) => ({ key, labelKey, fallback, options: decorated.filter((option) => option.group === key) }))
      .filter((group) => group.options.length);
  };

  const SALE_RATES = {
    25: [['vatCode.sale.rate25', '25 % · Salg, høy sats'], ['vatCode.sale.rate25Context', 'Salget er avgiftspliktig med alminnelig sats 25 %.'], OUTPUT_EFFECT],
    15: [['vatCode.sale.rate15', '15 % · Salg, middels sats'], ['vatCode.sale.rate15Context', 'Salget er avgiftspliktig med middels sats 15 %, normalt næringsmidler.'], OUTPUT_EFFECT],
    12: [['vatCode.sale.rate12', '12 % · Salg, lav sats'], ['vatCode.sale.rate12Context', 'Salget er avgiftspliktig med lav sats 12 %, blant annet persontransport, overnatting og adgang til kultur og idrett.'], OUTPUT_EFFECT],
    0: [['vatCode.sale.rate0', 'Ingen MVA-kode · ingen MVA-behandling'],
      ['vatCode.sale.rate0Context', 'Innbetalingen skal ikke ha norsk utgående MVA.'],
      ['vatCode.sale.rate0Effect', 'Hele beløpet føres som inntekt uten beregnet utgående MVA. Er salget fritatt, utførsel eller omvendt avgiftsplikt, hører det hjemme som salgsbilag under Annet salg, der de kodene finnes.']],
  };

  // Banklinjer for salg baerer bare en sats, ikke en fri MVA-kode. Menyen viser
  // derfor satsene som salg, ikke som kjoep.
  const salesGroups = ({ rates = [0, 25, 15, 12] } = {}) => {
    const allowed = [0, 25, 15, 12].filter((rate) => (Array.isArray(rates) ? rates : []).map(Number).includes(rate));
    const optionForRate = (rate) => {
      const [label, context, effect] = SALE_RATES[rate];
      return {
        value: String(rate),
        labelKey: label[0],
        fallback: label[1],
        contextKey: context[0],
        contextFallback: context[1],
        effectKey: effect[0],
        effectFallback: effect[1],
        scopeKey: rate ? SALE_SCOPE[0] : NEUTRAL_SCOPE[0],
        scopeFallback: rate ? SALE_SCOPE[1] : NEUTRAL_SCOPE[1],
        selectable: true,
      };
    };
    const groups = [];
    if (allowed.includes(0)) groups.push({ key: 'none', labelKey: 'vatCode.group.none', fallback: 'Ingen MVA-kode', options: [optionForRate(0)] });
    const rated = allowed.filter((rate) => rate > 0);
    if (rated.length) groups.push({ key: 'sale', labelKey: 'vatCode.group.sale', fallback: 'Salg med norsk MVA', options: rated.map(optionForRate) });
    return groups;
  };

  // Kallstedene kjenner kontoen, ikke retningen. Denne tar hele veien i ett steg
  // slik at sidene slipper aa utlede retning selv.
  const groupsForAccount = ({ options = [], account = '', value = '' } = {}) =>
    manualGroups({ options, direction: directionForAccount(account), value });

  // Naar kontoen paa en linje byttes, er en kode som peker motsatt vei en rest
  // fra forrige konto: utgaaende MVA hoerer bare paa salgskontoer, og inngaaende
  // kan ikke staa paa en salgskonto. Noeytrale kontoer beholder inngaaende kode.
  const codeConflictsWithAccount = (value, account) => {
    const codeDirection = MANUAL_CODES[value]?.[1] || '';
    if (!codeDirection) return false;
    const accountDirection = directionForAccount(account);
    return codeDirection === 'sale' ? accountDirection !== 'sale' : Boolean(accountDirection) && accountDirection !== codeDirection;
  };

  const optionFor = (value, groups = []) => groups
    .flatMap((group) => group.options)
    .find((option) => option.value === value) || null;

  // Fakturalinjer bruker salgsvalgene fra backend (getSalesVatOptions kjenner
  // land og MVA-registrering). Her legges bare gruppe og forklaring paa. Tekstene
  // beskriver norsk MVA, saa andre land faar valgene uten forklaring til de har
  // egne tekster.
  const INVOICE_SALE_GROUP_ORDER = [
    ['taxable', 'vatCode.invoice.group.taxable', 'Avgiftspliktig salg'],
    ['noVat', 'vatCode.invoice.group.noVat', 'Fritatt eller utenfor MVA'],
    ['special', 'vatCode.invoice.group.special', 'Eksport og omvendt avgiftsplikt'],
  ];
  const NO_INVOICE_SALE_TEXT = {
    25: [SALE_RATES[25][1], OUTPUT_EFFECT],
    15: [SALE_RATES[15][1], OUTPUT_EFFECT],
    12: [SALE_RATES[12][1], OUTPUT_EFFECT],
    zeroRated: [['vatCode.invoice.zeroRatedContext', 'Salget er omfattet av MVA-loven, men fritatt (nullsats).'],
      ['vatCode.invoice.zeroRatedEffect', 'Plumme beregner ingen utgående MVA, men tar omsetningen med i MVA-meldingen som fritatt omsetning (kode 5).']],
    exempt: [['vatCode.invoice.exemptContext', 'Salget er unntatt fra MVA-loven, for eksempel helsetjenester, undervisning eller utleie av fast eiendom.'],
      ['vatCode.invoice.exemptEffect', 'Plumme beregner ingen MVA, og salget tas ikke med i MVA-meldingen.']],
    salesReverseCharge51: [['vatCode.invoice.reverse51Context', 'Innenlandsk salg med omvendt avgiftsplikt, der kjøperen beregner MVA, for eksempel klimakvoter og gull.'],
      ['vatCode.invoice.reverse51Effect', 'Fakturaen har ingen utgående MVA. Omsetningen rapporteres med kode 51.']],
    export52: [['vatCode.invoice.export52Context', 'Varer eller tjenester som leveres til utlandet.'],
      ['vatCode.invoice.export52Effect', 'Plumme beregner ingen utgående MVA. Omsetningen rapporteres som utførsel med kode 52.']],
  };
  const NOT_REGISTERED_TEXT = [['vatCode.invoice.notRegisteredContext', 'Foretaket er ikke registrert i Merverdiavgiftsregisteret og skal ikke beregne MVA på salg.'],
    ['vatCode.invoice.notRegisteredEffect', 'Hele beløpet føres som inntekt, og salget tas ikke med i noen MVA-melding.']];

  const invoiceSaleGroupFor = (value) => (
    value === 'zeroRated' || value === 'exempt' ? 'noVat'
      : value === 'salesReverseCharge51' || value === 'export52' ? 'special'
        : 'taxable'
  );

  const invoiceSalesGroups = ({ options = [], country = 'NO', vatRegistered = true } = {}) => {
    const isNorway = String(country || 'NO').toUpperCase() === 'NO';
    const decorated = (Array.isArray(options) ? options : []).map((option) => {
      const text = !vatRegistered ? NOT_REGISTERED_TEXT : isNorway ? NO_INVOICE_SALE_TEXT[option.value] : null;
      return {
        value: option.value,
        label: option.label,
        group: invoiceSaleGroupFor(option.value),
        scopeKey: SALE_SCOPE[0],
        scopeFallback: SALE_SCOPE[1],
        contextKey: text ? text[0][0] : '',
        contextFallback: text ? text[0][1] : '',
        effectKey: text ? text[1][0] : '',
        effectFallback: text ? text[1][1] : '',
        selectable: option.disabled !== true,
      };
    });
    return INVOICE_SALE_GROUP_ORDER
      .map(([key, labelKey, fallback]) => ({ key, labelKey, fallback, options: decorated.filter((option) => option.group === key) }))
      .filter((group) => group.options.length);
  };

  global.PlummeVatCodeCatalog = { directionForAccount, codeConflictsWithAccount, manualGroups, groupsForAccount, salesGroups, invoiceSalesGroups, optionFor };
})(typeof window !== 'undefined' ? window : globalThis);
